import axios from "helpers/_axios";
export const LOADING_ACCURACY = "LOADING_ACCURACY";
export const ERROR_ACCURACY = "ERROR_ACCURACY";
export const GET_ACCURACY = "GET_ACCURACY";

export const getAccuracy =
  ({ clientId, userId = "", page = 1 }) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_ACCURACY,
        payload: true
      });
      const result = await axios().get(`/accuracy/${clientId}?page=${page}`, {
        params: {
          user_id: userId
        }
      });
      dispatch({
        type: LOADING_ACCURACY,
        payload: false
      });
      dispatch({
        type: GET_ACCURACY,
        payload: result.data.data[0]
      });
      dispatch({
        type: ERROR_ACCURACY,
        payload: null
      });
    } catch (error) {
      dispatch({
        type: LOADING_ACCURACY,
        payload: false
      });
      dispatch({
        type: GET_ACCURACY,
        payload: null
      });
      dispatch({
        type: ERROR_ACCURACY,
        payload: error
      });
    }
  };
